const COMBINING_MARKS_REGEX = /[\u0300-\u036f]/g;
const WHITESPACE_REGEX = /\s+/g;

export function normalizeSearchText(value, { compact = false } = {}) {
  const normalized = String(value ?? "")
    .toLocaleLowerCase("tr-TR")
    .normalize("NFD")
    .replace(COMBINING_MARKS_REGEX, "")
    .replace(/ı/g, "i");

  return (compact ? normalized.replace(WHITESPACE_REGEX, "") : normalized).trim();
}

export function includesSearchText(value, normalizedQuery, options) {
  if (!normalizedQuery) return true;
  return normalizeSearchText(value, options).includes(normalizedQuery);
}
